<template>
  <div>
    <section class="page-offset bg-sand pb-20">
      <div class="container">
        <div class="grid grid-cols-1 gap-x-4 lg:grid-cols-3">
          <div class="col-span-2">
            <h2 class="heading">
              {{ $t('Members') }}
            </h2>
          </div>
          <div class="col-span-1 w-3/4 sm:ml-auto">
            <div class="label label-left relative isolate flex w-full items-center gap-5">
              <IconsActionsSearch />
              <FormKit
                v-model="query"
                autocomplete="off"
                type="text"
                outer-class="!m-0 w-full"
                input-class="!placeholder-black/20 text-black/80 font-normal !border-0 text-base xl:text-xl"
                placeholder="Zoek op naam..."
                :delay="500"
              />
            </div>
          </div>
        </div>

        <div
          v-if="sectors.length > 0"
          class="grid grid-cols-1 gap-x-4 lg:grid-cols-3"
        >
          <div class="col-span-1">
            <ul>
              <li
                v-for="sector in sectors"
                :key="sector.id"
                class="py-2"
              >
                <button
                  class="text-lg font-bold no-underline"
                  :class="selectedSector.includes(sector) ? 'text-purple' : 'text-blue'"
                  @click="toggleSector(sector)"
                >
                  {{ sector.title }}
                </button>
              </li>
            </ul>
          </div>
          <div class="col-span-1">
            <img
              src="~/assets/images/netherlands.svg"
              alt="Google Maps"
            >
          </div>
          <div class="col-span-1 sm:ml-auto sm:w-3/4">
            <h2 class="heading-sub">
              {{ $t('All members') }}
            </h2>
            <ul class="mb-4 divide-y divide-black/10">
              <li
                v-for="member in members.data"
                :key="member.id"
                class="py-2.5"
              >
                <NuxtLink
                  :to="localePath({name: 'members-slug', params: {slug: member.slug}})"
                  class="text-green-darkest hover:text-green-darkest cursor-pointer text-base font-medium no-underline hover:scale-50 hover:font-semibold hover:underline"
                >
                  {{ member.title }}
                </NuxtLink>
              </li>
            </ul>
            <p v-if="members.total === 0">
              {{ $t('No results') }}
            </p>
            <div v-if="members.total > 0">
              <MembersPagination
                :current-page="currentPage"
                :total-pages="totalPages"
                @update:current-page="currentPage = $event"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {type Sector, useMembersQuery, useSectorsQuery} from '~/graphql/graphql';

const localePath = useLocalePath();
const query = ref('');
const selectedSector = ref<Sector[]>([]);
const currentPage = ref(1);

const {result: sectorsQueryResult} = useSectorsQuery();
const sectors = computed(() => sectorsQueryResult.value?.sectors ?? []);

const {result: queryResult, onResult} = useMembersQuery(() => ({
  query: query.value,
  sector: selectedSector.value.map(s => s.title),
  page: currentPage.value,
}));
const members = computed(() => queryResult.value?.members ?? []);

onResult(() => {
  if (process.client) {
    window.scrollTo(0, 0);
  }
});

const totalPages = computed(() => members.value.total < members.value.per_page ? 1 : Math.ceil(members.value.total / members.value.per_page));

function toggleSector(sector: Sector) {
  selectedSector.value = selectedSector.value.includes(sector) ? selectedSector.value.filter(s => s === sector) : [sector];
}

watch(selectedSector, (newSelectedSector) => {
  selectedSector.value = newSelectedSector;
});
</script>
